import { Injectable } from '@angular/core';
import { BehaviorSubject} from 'rxjs';
import {Availability, Gather, JobPosting} from '../gather-typings';
import { GatherStateService } from './gather-state.service';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {
  private jobPosting$ = new BehaviorSubject<JobPosting>({
    jobPostingId: -1,
    jobTitle: '',
    jobDescription: '',
    clientDescription: '',
    otherReqs: '',
    city: '',
    state: '',
    startDate: '',
    clientName: '',
    jobTypeId: -1,
    isPortfolioAssociatedJobType: false,
    salary: '',
    orderId: -1,
    orderStatusId: -1,
    placementTypeId: -1,
    countryId: -1,
    clientServiceManagerName: '',
    clientServiceManagerEmail: '',
    jobLocation: '',
    firmPay: false,
    hourId: -1,
    duration: '',
    shareClientName: false
  });
  private talentAvailability$ = new BehaviorSubject<Availability>({
    availabilityType: -1,
    numWeeksNoticeNeeded: -1,
    availabilityDate: null,
    checkInDate: null,
    activelySearchingSelected: false,
    personId: -1,
    activelySearchingDateEntered: null,
    modDate: null,
    trackingId: '',
    gatherResponseDate: null,
    alreadyResponded: false,
    notes: '',
    hourlyRate: '',
    annualSalary: '',
    projectRate: ''
  });
  private gather$ = new BehaviorSubject<Gather>({
    orderId: -1,
    gatherId: -1,
    talentPersonId: -1,
    divisionBrand: '',
    showOutsideReview: false,
    outsideReviewQuantity: -1,
    talent: {
      id: -1,
      firstName: '',
      middleName: '',
      lastName: '',
      fullName: '',
      title: '',
      suffix: '',
      preferredName: '',
      homeMarketCountryId: -1,
      altLangInfo: []
    },
    countryCode: '',
    showEeocForm: false,
    eeocFormUuid: '',
    gatherType: '',
    talentHomeMarketCountryId: -1
  });
  private trackingId$ = new BehaviorSubject<string>('');
  private interest$ = new BehaviorSubject<string>('');

  constructor(private gatherStateService: GatherStateService) {}

  get jobPosting(): BehaviorSubject<JobPosting> {
    return this.jobPosting$;
  }

  setJobPosting(val: JobPosting): void {
    this.jobPosting$.next(val);
  }

  get gather(): BehaviorSubject<Gather> {
    return this.gather$;
  }

  setGather(gather: Gather): void {
    this.gatherStateService.setBrand(gather);
    this.gather$.next(gather);
  }

  get trackingId(): BehaviorSubject<string> {
    return this.trackingId$;
  }

  setTrackingId(val: string): void {
    this.trackingId$.next(val);
  }

  get talentAvailability(): BehaviorSubject<Availability> {
    return this.talentAvailability$;
  }

  setTalentAvailability(val: Availability): void {
    this.talentAvailability$.next(val);
  }

  get interest(): string {
    return this.interest$.getValue();
  }

  setInterest(val: string): void {
    this.interest$.next(val);
  }
}
